module.exports = __webpack_public_path__ + "img/btn-add.9ed4862e.svg";